
import {ProductsRelDocs} from "../../interfaces";
import ProductPriceFormat from "../../../product-price/product-price-format";
interface IProductBuyButtonProps {
    product: ProductsRelDocs,
    isGoogleShoppingFeed?: boolean,
}
/**
 * the entry point
 */
const StickyPrice = (props: IProductBuyButtonProps) => {

    const product = props.product;
    const withCouponEnabled = product.couponCampaignID > 0;
    const isWithCoupon = withCouponEnabled && !props.isGoogleShoppingFeed && product.couponPrice > 0;
    const isSamePrice = product.msrp === product.skuPrice;

    return (

            <>
                {
                    <div className={`flex flex-col mr-2 md:mr-4`}>
                        <div className={`row-1 flex flex-row justify-end`}>
                        {/* prices row #1: different prices / with coupon */}
                        {
                            (product.couponPrice > 0 || !isSamePrice) &&
                            <div className="flex items-center hidden md:block">

                                {/* MSRP price */}
                                <div className="full-price text-sm lg:text-lg mr-2 text-gray-500">
                                    <s aria-hidden="true"><ProductPriceFormat price={ product.msrp } accessible={ false } /></s>
                                    <span className="sr-only">Full Price ${ product.msrp }</span>
                                </div>
                            </div>
                        }
                        {/* prices row #2 */}
                        <div className="row-2 flex items-center">

                            {/* main price: if 'with coupon' exists -> 'with coupon' price, otherwise sku price */}
                            <div className="text-lg lg:text-xl font-bold">
                                {
                                    isWithCoupon &&
                                    <span>
                        <ProductPriceFormat price={ product.couponPrice } />&nbsp;

                                        <span className="sr-only">
                                            With Coupon: <span>{ product.couponCode }</span>
                                        </span>
                                    </span>
                                }

                                { !isWithCoupon && <span><ProductPriceFormat price={ product.skuPrice } /></span> }
                            </div>
                        </div>
                        </div>

                        {/* prices row #1: same price */}
                        {/*{
                            (isSamePrice && product.couponPrice <= 0) &&
                            <div className="flex items-center text-base ">Now</div>
                        }*/}


                        {/* prices row #3 */}
                        {
                            product.couponCode &&
                            <div className="flex items-center hidden md:block">
                                <div className="font-bold flex" aria-hidden={ true }>With Coupon: <span className="text-red">{ product.couponCode }</span></div>
                            </div>
                        }


                    </div>
                }
            </>
    )
};

export default StickyPrice;